import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { ThemeOverride, ThemeSurface } from '@wix/da-react-context/pkg/ThemeContext';
import ScrollableContent from '@wix/da-ds/pkg/ScrollableContent';
import MediaSourceMenu from '../MediaSourceMenu/Mobile';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import Breadcrumbs from '../Breadcrumbs';
import UploadButton from '../UploadButton';
import withFileUpload from '../../_hocs/withFileUpload';
import popupInnerLayoutStyles from './PopupInnerLayout.scss';
const ON_SCROLL_BOTTOM_DISTANCE = 200;
const enhance = compose(withFileUpload, withMobileContext, withCurrentGallection);
class PopupInnerLayout extends React.PureComponent {
    render() {
        const { scrollableContent, sideBarContent, onNotScrollable } = this.props;
        return /*#__PURE__*/ React.createElement(Flex, {
            className: popupInnerLayoutStyles['root']
        }, /*#__PURE__*/ React.createElement(Flex, {
            fullWidth: true,
            direction: "column"
        }, this.renderHeader(), /*#__PURE__*/ React.createElement(ScrollableContent, {
            className: popupInnerLayoutStyles['scrollable-content'],
            onScrolled: this.onScrolled,
            onNotScrollable: onNotScrollable
        }, /*#__PURE__*/ React.createElement(ThemeOverride, {
            themeSurface: ThemeSurface.SECONDARY
        }, scrollableContent))), sideBarContent);
    }
    renderHeader() {
        const { isMobile, oneRowHeader, headerExtrasBottomZone } = this.props;
        const { isHeaderSticky } = this.state;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: classnames(popupInnerLayoutStyles['header'], isHeaderSticky && popupInnerLayoutStyles['sticky'])
        }, /*#__PURE__*/ React.createElement(ThemeOverride, {
            themeSurface: ThemeSurface.SECONDARY,
            className: popupInnerLayoutStyles['header-theme-wrapper']
        }, isMobile ? this.renderMobileHeader() : this.renderDesktopHeader(), !oneRowHeader && this.renderSubtitle(), !isMobile && headerExtrasBottomZone)), isMobile && headerExtrasBottomZone);
    }
    constructor(...args){
        super(...args);
        _define_property(this, "state", {
            isHeaderSticky: false
        });
        _define_property(this, "renderMobileHeader", ()=>{
            const { oneRowHeader, headerExtrasRightZone, allowUploads = true, currentFolderId } = this.props;
            return /*#__PURE__*/ React.createElement("div", {
                className: popupInnerLayoutStyles['header-top-row']
            }, oneRowHeader && this.renderSubtitle(), /*#__PURE__*/ React.createElement("div", {
                className: popupInnerLayoutStyles['header-bottom-row']
            }, currentFolderId ? /*#__PURE__*/ React.createElement(Breadcrumbs, null) : /*#__PURE__*/ React.createElement(MediaSourceMenu, null), headerExtrasRightZone), allowUploads && /*#__PURE__*/ React.createElement(UploadButton, null));
        });
        _define_property(this, "renderDesktopHeader", ()=>{
            const { oneRowHeader, headerExtrasRightZone } = this.props;
            return /*#__PURE__*/ React.createElement("div", {
                className: popupInnerLayoutStyles['header-top-row']
            }, /*#__PURE__*/ React.createElement(Breadcrumbs, null), oneRowHeader && this.renderSubtitle(), /*#__PURE__*/ React.createElement("div", {
                className: popupInnerLayoutStyles['header-extras-right-zone']
            }, headerExtrasRightZone));
        });
        _define_property(this, "renderSubtitle", ()=>{
            const { headerSubtitle } = this.props;
            if (!headerSubtitle) {
                return null;
            }
            return /*#__PURE__*/ React.createElement("div", {
                className: popupInnerLayoutStyles['header-subtitle']
            }, headerSubtitle);
        });
        _define_property(this, "onScrolled", (scrollTop, distanceToBottom)=>{
            const isHeaderSticky = scrollTop !== 0;
            this.setState({
                isHeaderSticky
            });
            if (distanceToBottom <= ON_SCROLL_BOTTOM_DISTANCE) {
                this.props.onScrolledToBottom && this.props.onScrolledToBottom();
            }
        });
    }
}
export default enhance(PopupInnerLayout);
